export enum BUTTON_TYPES {
	Primary = 'primary',
	Secondary = 'secondary',
	Danger = 'danger',
	Borderless = 'borderless'
}

export enum BUTTON_SIZES {
	Small = 'sm',
	ExtraSmall = 'xs',
	Large = 'lg'
}
